module.exports = __webpack_public_path__ + "img/atramex-building.9c2d208.jpg";